import { useAuthStore } from '@fides/fides-react-components';
import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

interface PrivateRouteProps extends RouteProps {
  prefix?: string,
  title?: string;
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
export function PrivateRoute({ children, title, prefix, ...rest }: PrivateRouteProps) {
  const userIsLoggedIn = useAuthStore(state => state.userIsLoggedIn);
  
  React.useEffect(() => {
    if (!rest.exact) return; // do not change title on partial match
    const PREFIX = prefix ?? 'Download Center';
    document.title = title
      ? `${PREFIX} > ${title}`
      : PREFIX;
  }, [title, prefix, rest.exact]);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        userIsLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/loggedout',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
